import { Link, useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { HoneMark } from '../../components/HoneMark';
import { HoneWordmark } from '../../components/HoneWordmark';

const useLogoStyles = makeStyles({
  full: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  mark: {
    height: 14,
    width: 'auto',
  },
  markOnly: {
    height: 18,
    width: 'auto',
  },
  divider: {
    width: 1,
    height: 14,
    background: 'var(--hone-portal-hairline-strong)',
    flex: 'none',
  },
  // "Portal" is set in mono to read as a system label, not a second wordmark.
  label: {
    fontFamily: 'var(--bui-font-monospace)',
    fontSize: 10.5,
    letterSpacing: '0.02em',
    color: 'var(--bui-fg-secondary)',
    whiteSpace: 'nowrap',
  },
});

const useSidebarLogoStyles = makeStyles({
  // Brand row geometry from the sidebar spec: 20px top / 14px bottom, 16px inset.
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 16px 14px',
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    // Dark-in-light / light-in-dark: the mark and wordmark render with
    // fill=currentColor, so they follow this color in both themes.
    color: 'var(--bui-fg-primary)',
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const logoClasses = useLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? (
          <div className={logoClasses.full}>
            <HoneWordmark className={logoClasses.mark} />
            <span className={logoClasses.divider} />
            <span className={logoClasses.label}>Portal</span>
          </div>
        ) : (
          <HoneMark className={logoClasses.markOnly} />
        )}
      </Link>
    </div>
  );
};
